<app-kymw1400-koma-page id="KYMW1400KomaPageLeftViewHelper" #KYMW1400KomaPageLeftViewHelper [leftOrRight]="'left'"
  (mousedown)="eventWindow_MOUSE_DOWNHandler()">
</app-kymw1400-koma-page>
